import { combineReducers } from "redux";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { ACCESS_TOKEN, ADMIN, LOGIN_REQUEST, LOGOUT, REFRESH_TOKEN } from "./constants";
import { getInitialAuth } from "./initial";
import { Action, AdminUser } from "./types";

const initAuth = getInitialAuth();

function isAuthenticated(state: boolean = initAuth.isAuthenticated, action: Action): boolean {
  switch (action.type) {
    case getSuccessActionType(LOGIN_REQUEST):
      localStorage.setItem(ACCESS_TOKEN, action.payload.data.access_token);
      localStorage.setItem(REFRESH_TOKEN, action.payload.data.refresh_token);
      return true;

    case getFailureActionType(LOGIN_REQUEST):
    case LOGIN_REQUEST:
      return false;

    case LOGOUT:
      localStorage.removeItem(ACCESS_TOKEN);
      localStorage.removeItem(REFRESH_TOKEN);
      return false;
    default:
      return state;
  }
}

function admin(state: AdminUser = initAuth.admin, action: Action): AdminUser {
  switch (action.type) {
    case getSuccessActionType(LOGIN_REQUEST):
      localStorage.setItem(ADMIN, JSON.stringify(action.payload.data.user));
      return action.payload.data.user;

    case getFailureActionType(LOGIN_REQUEST):
    case LOGIN_REQUEST:
      return initAuth.admin;

    case LOGOUT:
      return initAuth.admin;

    default:
      return state;
  }
}

export const auth = combineReducers({ isAuthenticated, admin });
